import type { IconData } from '@stacksjs/iconify-core'

export const foodDrinkBread: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 4.57h-1.52V3.05h-1.53V1.52h-3.04V0H7.61v1.52h10.67v1.53h3.05v1.52h1.52V6.1h1.53v7.61h-1.53v1.53h-1.52v15.24H4.57V32H25.9v-1.52h1.52v-1.53h1.53v-1.52h1.52V13.71H32V6.1h-1.53z\"/><path fill=\"currentColor\" d=\"M15.23 21.33h1.53v1.53h-1.53Zm-1.52-3.04h1.52v1.52h-1.52Zm-4.57 4.57h6.09v1.52H9.14Zm0-4.57h1.52v1.52H9.14Zm-1.53 3.04h1.53v1.53H7.61ZM4.57 1.52h3.04v1.53H4.57ZM3.04 15.24h1.53v15.24H3.04Zm0-12.19h1.53v1.52H3.04ZM1.52 13.71h1.52v1.53H1.52Zm0-9.14h1.52V6.1H1.52ZM0 6.1h1.52v7.61H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default foodDrinkBread
